<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" title="Subcontractor Status" size="lg" ok-title="Update Subcontractor Status" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" :ok-disabled="saving" ref="subStatusModal" :no-close-on-backdrop="true" scrollable>

            <div style="min-height: 350px;">
                <div v-if="loading" class="text-center">
                    <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                </div>
                <div v-else>
                    <div class="form-group row">
                        <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.status_id }">
                            Status: <i class="fa fa-asterisk text-danger"></i>
                        </label>
                        <div class="col-md-8">
                            <b-form-select v-model="payload.status_id" :options="statuses" :class="{'is-invalid': errors.status_id }" />

                            <span v-if="errors.status_id" class="text-danger">
                                <span v-for="error in errors.status_id">{{ error }}</span>
                            </span>
                        </div>
                    </div>

                    <div v-bind:class="{ 'form-group row': true, 'has-error': errors.valid_until }" v-if="payload.status_id == 3 || payload.status_id == 5">
                        <label class="col-md-3 col-12 col-form-label text-sm-right">
                            Approved Until: <i class="fa fa-asterisk text-danger"></i>
                        </label>
                        <div class="col-sm-8">
                            <date-picker :value="readDate(payload.valid_until)" @input="payload.valid_until = writeDate($event)" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors.valid_until }" placeholder="Approved Until"></date-picker>
                            <span v-if="errors.valid_until" class="text-danger">
                                <span v-for="error in errors.valid_until">{{ error }}</span>
                            </span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.comment }">
                            Status Note: <i class="fa fa-asterisk text-danger"></i><br>
                            <small>
                                These notes will be attached to the Subcontractor as a comment.
                            </small>
                        </label>
                        <div class="col-md-8">
                            <b-form-textarea v-model="payload.comment" :class="{'is-invalid': errors.comment }" :rows="4" :max-row="8" placeholder="Enter Status Comment"></b-form-textarea>

                            <span v-if="errors.comment" class="text-danger">
                                <span v-for="error in errors.comment">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {

            subcontractorId: {
                type: Number,
                default: null,
            },

        },

        data: function() {
            return {
                openModal: false,
                saving: false,
                loading: true,
                errors: {},
                statuses: [],
                payload: {
                    status_id: '',
                    valid_until: null,
                    comment: '',
                },
            }
        },

        computed: {

        },

        methods: {

            readDate(date) {
                //Check for null
                if(!date)
                {
                    return null;
                }

                //Send it
                return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            },

            writeDate(date) {
                //Check for null
                if(!date || date == '')
                {
                    return null;
                }

                //Send it
                return moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD');
            },

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the errors
                this.errors = {};

                //Reset the values
                this.payload = {
                    status_id: '',
                    valid_until: null,
                    comment: '',
                };
            },

            handleOk: function(bvEvt) {
               //Stops the modal from closing
               bvEvt.preventDefault();

               //Do it
               this.saveStatus();
            },

            setModel(payload){
                //Set the main payload
                this.payload = payload;

                // If we don't find the id, default to empty
                if (this.statuses.filter(e => e.value == payload.status_id).length === 0)
                {
                    this.payload.status_id = '';
                }
            },

            showModal(){
                //Open the modal
                this.openModal = true;
            },

            getStatuses(){
                if (this.statuses.length > 1)
                {
                    return;
                }

                //Get the statuses
                this.$http
                    .get('subcontractors/statuses')
                    .then(response => {
                        //Set all the data
                        this.statuses = [{value: '', text: '-- Select a Status --'}];
                        this.statuses = this.statuses.concat(response.data);
                    })
                    .catch(response => {

                    })
                    .then(response => {
                        this.loading = false;
                    });
            },

            saveStatus(){
                this.saving = true;
                //Send it
                this.$http
                .post('subcontractors/overall-status/' + this.subcontractorId, this.payload)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Subcontractor Status Updated');

                    //Emit ?
                    this.$emit('statusChanged', response.data);

                    //Close the modal
                    this.$refs.subStatusModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },
        },

        mounted() {
            //SEt the height
            //this.$refs.subStatusModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

            this.getStatuses();
        }
    }
</script>